module.exports = __webpack_public_path__ + "media/images/emoticons/motorsports-7f255d741ec3550a96218f5198a7db31.gif";